import { NavContentBlueprint } from '@backstage/plugin-app-react';
import { MyralisTopNav } from './MyralisTopNav';

export const SidebarContent = NavContentBlueprint.make({
  params: {
    component: ({ navItems }) => <MyralisTopNav navItems={navItems} />,
  },
});
